/**
 * MemberRouteWrapper supplies the CartProvider for nested member routes
 * when accessed by admins/staff (non-client roles). Keeps route trees DRY.
 * Also provides the shared mobile scrollport so staff member views scroll fully.
 */
import { Outlet } from 'react-router-dom';
import { CartProvider } from '../../contexts/CartContext';
import { MemberScrollShell } from '../../layout/MemberScrollShell';

export const MemberRouteWrapper = () => (
  <CartProvider>
    <div className="relative h-full min-h-0" data-testid="memberRouteWrapper_root">
      <MemberScrollShell>
        <Outlet />
      </MemberScrollShell>
    </div>
  </CartProvider>
);
